module.exports = __webpack_public_path__ + "img/e1369af.jpg";